/**
 * @file Redux mappers for composeModalHeader container
 */

import { MapStateToProps } from 'react-redux';

import AppState from '../../../models/state';

import { getIsDefaultDraftChanged } from '../helpers';

import { OwnProps, StateProps } from './types';

/**
 * Map Redux app state to component props
 *
 * @param appState                   Current app state
 * @param appState.drafts            Drafts in the state
 * @param appState.draftsAttachments Attachments drafts in the state
 * @param ownProps                   Passed props
 * @param ownProps.nodeType          The id of the draft
 * @returns                          Mapped state
 */
export const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = ({ drafts, draftsAttachments }, { nodeType }) => {
  const draft = drafts.get(nodeType);
  const attachmentsDraft = draftsAttachments.get(nodeType);

  if (draft === undefined || attachmentsDraft === undefined) {
    return {
      draft: null,
      isDraftChanged: false,
      status: null,
      title: '',
      topicId: null,
    };
  }

  const { status, title, templateTopicSaved } = draft;

  return {
    draft,
    isDraftChanged: getIsDefaultDraftChanged(draft, attachmentsDraft),
    status,
    title,
    topicId: templateTopicSaved,
  };
};
